'use strict';

angular.module('amexReconciliationApp')
  .component('poDataModal', {
    templateUrl: 'scripts/views/modals/po-data-modal.html',
    bindings: {
      closeModalCallback: '&',
      transactions: '<'
    },
    controller: function ($scope,
                          PoModel,
                          BillingCycleModel,
                          TransactionsModel,
                          UserModel,
                          toastr,
                          $translate,
                          AssociateAccountingDetailsRepository) {
      var self = this;
      var selectedPoId;
      var copyAccountingDetailsButtonPressed = false;

      self.closeModal = self.closeModalCallback;
      self.PoModel = PoModel;
      self.BillingCycleModel = BillingCycleModel;
      self.currentTpdBillingCycle = self.BillingCycleModel.billingCycles()[0];
      self.hideClosed = true;
      self.getCurrencyFormat = UserModel.getCurrencyFormat;

      self.poLoading = function () {
        return PoModel.loading();
      };

      self.handleBillingCycleChange = function () {
        PoModel.getPo(self.transactions, self.currentTpdBillingCycle, self.hideClosed);
      };

      self.handleBillingCycleChange();

      self.selectPoRow = function (poId) {
        selectedPoId = poId;
      };

      self.rowIsSelected = function (poId) {
        if (poId === selectedPoId) {
          return true;
        }
        return false;
      };

      self.copyAccountingDetailsButtonDisabled = function () {
        if (copyAccountingDetailsButtonPressed || selectedPoId === undefined) {
          return true;
        }
        return false;
      };

      self.copyAccountingDetails = function () {
        copyAccountingDetailsButtonPressed = true;

        var selectedTransactionIds = _.map(self.transactions, 'id');

        AssociateAccountingDetailsRepository.copy(selectedTransactionIds, selectedPoId)
          .then(function () {
            TransactionsModel.refreshTransactions(selectedTransactionIds)
              .then(function() {
                self.transactions = updateSelectedTransactions(selectedTransactionIds);
              })
              .then(successCopyingCallback)
              .catch(errorCopyingCallback);
          })
          .catch(errorCopyingCallback)
          .finally(function() {self.closeModal();});
      };

      self.linkPoData = function () {
        copyAccountingDetailsButtonPressed = true;

        var selectedTransactionIds = _.map(self.transactions, 'id');

        AssociateAccountingDetailsRepository.link(selectedTransactionIds, selectedPoId)
          .then(function () {
            TransactionsModel.refreshTransactions(selectedTransactionIds)
              .then(function() {
                self.transactions = updateSelectedTransactions(selectedTransactionIds);
              })
              .then(successLinkingCallback)
              .catch(errorLinkingCallback);
          })
          .catch(errorLinkingCallback)
          .finally(function() {self.closeModal();});
      };

      self.populateFilter = function ($event, type) {
        self.poSearchTerm = _.words($event.target.text, /[^\s]+/g).join(' ');
      };

      self.getPOQuantity = function (poData) {
        if(poData.dataLines.length > 0) {
          return poData.dataLines[0].quantity;
        }else{
          return '';
        }
      };

      self.getPODescription = function (poData) {
        if(poData.dataLines.length > 0) {
          return poData.dataLines[0].description;
        }else{
          return '';
        }
      };

      function successLinkingCallback() {
        if(anyInvalidTravelDataAccountingValues()) {
          toastr.success($translate.instant('thirdPartyData.poDataSuccessfulLinkAndCopyWithDefaults'));
        } else {
          toastr.success($translate.instant('thirdPartyData.poDataSuccessfulLinkAndCopy'));
        }
      }

      function successCopyingCallback() {
        if(anyInvalidTravelDataAccountingValues()) {
          toastr.success($translate.instant('thirdPartyData.poDataSuccessfulCopyWithDefaults'));
        } else {
          toastr.success($translate.instant('thirdPartyData.poDataSuccessfulCopy'));
        }
      }

      function errorLinkingCallback() {
        toastr.error('Error linking PO data.');
      }

      function errorCopyingCallback() {
        toastr.error('Error copying PO data.');
      }

      function anyInvalidTravelDataAccountingValues() {
        return _.some(self.transactions, function(transaction){
          return _.isEqual(_.get(transaction, 'details.exceptionNote', ''), '@EXC_VALID_MULTI');
        });
      }

      function updateSelectedTransactions(selectedTransactionIds) {
        return _.filter(TransactionsModel.transactions(),function(transaction) {
          return _.includes(selectedTransactionIds, _.get(transaction, 'id', ''));});
      }
    }
  });




//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/poDataModal.js
// module id = 465
// module chunks = 0